import createAxios from './api'

const PATH = 'trustx'

export default {
  async listProcessInstances(q) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances`, {
      params: {
        ...q
      }
    })

    return resp.data
  },

  async getProcessInstance(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}`)
    return resp.data
  },

  async getUserData(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}/userdata`)
    return resp.data
  },

  async getUserDataChecks(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}/userdata/checks`)
    return resp.data
  },

  async getProcessInstanceMetrics(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}/metrics`)
    return resp.data
  },

  async getProcessInstanceData(id, path) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}/userdata/getdata`, {
      params: { path: path }
    })
    return resp.data
  },

  async getBpmnFile() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/bpmnFile`)
    return resp.data
  },

  async getUserDataArchive(id, password) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/processInstances/${id}/userdataarchive`, { config: { password } }, { responseType: 'blob' })
    return resp.data
  },

  async downloadDocument(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/processInstances/${id}/file`, {
      headers: {
        Accept: 'application/octet-stream'
      },
      responseType: 'blob'
    })
    return resp.data
  },

  async documentExists(id) {
    const axios = await createAxios()

    const resp = await axios.head(`${PATH}/processInstances/${id}/file`, {
      validateStatus: status => status === 200 || status === 404
    })
    return {
      exists: resp.status === 200,
      headers: resp.headers
    }
  }
}
